<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Left Section - Logo and Social -->
        <div class="footer-left">
          <div class="footer-logo">
            <img src="/img/logo%20text%20white.png" alt="Invoice Scan" style="height: 32px" />
          </div>
          <p class="footer-description">{{ $t('footer.description') }}</p>
          <div class="footer-social">
            <a href="https://www.facebook.com/profile.php?id=61584115213294" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Follow us on Facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Center Sections - Links Grid -->
        <div class="footer-links-grid">
          <div class="footer-column">
            <h4 class="footer-heading">{{ $t('footer.aboutInvoiceScan') }}</h4>
            <ul class="footer-links">
              <li><router-link to="/about">{{ $t('footer.aboutUs') }}</router-link></li>
              <li><router-link to="/resources">{{ $t('footer.resources') }}</router-link></li>
              <li><router-link to="/careers">{{ $t('footer.careers') }}</router-link></li>
              <li><router-link to="/blog">{{ $t('footer.blog') }}</router-link></li>
            </ul>
          </div>

          <div class="footer-column">
            <h4 class="footer-heading">{{ $t('footer.solutions') }}</h4>
            <ul class="footer-links">
              <li><a href="/docs/api">{{ $t('footer.api') }}</a></li>
              <li><router-link to="/integrations">{{ $t('footer.integrations') }}</router-link></li>
              <li><router-link to="/enterprise">{{ $t('footer.enterprise') }}</router-link></li>
              <li><router-link to="/terms">{{ $t('footer.termsOfService') }}</router-link></li>
            </ul>
          </div>

          <div class="footer-column">
            <h4 class="footer-heading">{{ $t('footer.getInTouch') }}</h4>
            <ul class="footer-links">
              <li><router-link to="/contact">{{ $t('footer.contactSales') }}</router-link></li>
              <li><h4 class="footer-heading">{{ $t('footer.support') }}</h4></li>
              <li><span>invoicescan.eu@gmail.com</span></li>
              <li><span>+359882814412</span></li>
              <li><span>+359895725972</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-bottom">
        <p>{{ $t('footer.rights') }}</p>
        <div class="footer-legal-links">
          <router-link to="/terms">{{ $t('footer.termsOfService') }}</router-link>
          <span class="separator">•</span>
          <a href="/privacy-policy.html" target="_blank">{{ $t('footer.privacyPolicy') }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
}

.container::before,
.container::after {
  content: none;
}

.footer {
  padding: 80px 0 40px;
  background: #1e293b;
  color: white;
  overflow: hidden;
  position: relative;
}

.footer::before {
  content: none;
}

.footer::after {
  content: none;
}

.footer-content {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 80px;
  margin-bottom: 60px;
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-description {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  font-size: 15px;
  margin: 0;
}

.footer-social {
  display: flex;
  gap: 12px;
}

.social-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.footer-links-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-heading {
  font-size: 14px;
  font-weight: 700;
  margin: 0;
  color: white;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a,
.footer-links span {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 13px;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: white;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin-bottom: 40px;
}

.footer-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
}

.footer-bottom p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.footer-legal-links {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.footer-legal-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-legal-links a:hover {
  color: rgba(255, 255, 255, 1);
}

.footer-legal-links .separator {
  color: rgba(255, 255, 255, 0.3);
}

@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-links-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
